export default __webpack_public_path__ + "static/media/archi_view2_d.1ee0ee25.webp";